import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Fix up links that unintentionally had ephemeral isCurrent flags persisted
// See https://github.com/webflow/webflow/issues/5482 for more details
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}, tag} = jsonNode;
  const hasIsCurrent = data && data.link && data.link.isCurrent !== undefined;

  return {
    needed: tag === 'a' && DomTypeUtils.isWebflowLink(data) && hasIsCurrent,
    logData: {
      msg: 'Link with data.link.isCurrent',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.link.isCurrent;
    },
  };
};
